import Box from "@mui/material/Box"
import PropTypes from "prop-types"

import {
  adminLiquidCardSx,
  adminLiquidPanelSx,
  adminLiquidSurfaceSx,
} from "../adminStyles"

const VARIANTS = {
  surface: adminLiquidSurfaceSx,
  panel: adminLiquidPanelSx,
  card: adminLiquidCardSx,
}

export default function AdminLiquidSurface({
  children,
  variant = "surface",
  sx,
  ...props
}) {
  return (
    <Box sx={{ ...VARIANTS[variant], ...sx }} {...props}>
      {children}
    </Box>
  )
}

AdminLiquidSurface.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(["surface", "panel", "card"]),
  sx: PropTypes.object,
}
